module.exports = __webpack_public_path__ + "img/Manuel-13.9f365e23.jpg";